module.exports = __webpack_public_path__ + "img/electricity.2b9478a7.png";